import React, { type FunctionComponent } from 'react'
import { Dialog } from '../Dialog'

type Props = {
  text: string
}

export const StatusDialog: FunctionComponent<Props> = ({ text }) => {
  return (
    <Dialog ariaLabel="Status">
      <div className="rounded-2xl bg-white shadow-md dark:bg-gray-900 p-9 flex flex-col items-center justify-center">
        <div className="loadingSpinner text-xl mb-4" />
        <p className="text-lg">{text}</p>
      </div>
    </Dialog>
  )
}
